import * as React from "react"
import type { SVGProps } from "react"
const SvgCost = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.93 19.6a.8.8 0 0 1-.6-.25 1 1 0 0 1-.27-.64v-.81a4 4 0 0 1-1.61-.8 4 4 0 0 1-1.07-1.3 1 1 0 0 1 0-.75q.16-.38.56-.52.38-.13.74 0 .36.12.6.48.34.5.82.8.48.28.93.28.75 0 1.22-.39.47-.37.47-.9 0-.54-.46-.93-.46-.4-1.6-.77a6.5 6.5 0 0 1-2.46-1.35 2.86 2.86 0 0 1-.06-3.73 3.2 3.2 0 0 1 1.92-1.09v-.79q0-.39.25-.64a.8.8 0 0 1 .6-.25q.35 0 .6.25a1 1 0 0 1 .23.64v.79q.69.14 1.27.48.57.34.95.91a.8.8 0 0 1 .11.74 1 1 0 0 1-.52.55q-.32.12-.69 0-.37-.1-.76-.44a1.3 1.3 0 0 0-.52-.34 2 2 0 0 0-.67-.11q-.64 0-1.05.3a.9.9 0 0 0-.4.74q0 .47.48.84.5.39 1.9.87 1.5.5 2.18 1.28t.69 2.05q0 1.17-.84 2.05-.84.89-2.13 1.11v.75a1 1 0 0 1-.24.64.8.8 0 0 1-.57.25" />
  </svg>
)
export default SvgCost
